export class PendingEmailVerificationError extends Error {
  constructor() {
    super('Failed to login. Pending email verification.')
    this.name = 'PendingEmailVerificationError'
  }
}
